/* ============================================================
   SONA FEY EDITORIAL — global.js
   Variant management, gallery, sticky ATC, nav, footer accordion
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Money formatting (uses shop currency from Liquid-rendered price as reference) ---------- */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
    var symbols = { USD: '$', GBP: '\u00a3', EUR: '\u20ac', TRY: '\u20ba' };
    var sym = symbols[currency] || (currency ? currency + ' ' : '$');
    return sym + amount;
  }

  /* ============================================================
     PRODUCT: variant management
     Reads variants JSON, maps selected option pills -> variant,
     updates: hidden input id, price, availability, ATC state,
     unavailable pill styling, featured media, URL (?variant=).
     ============================================================ */
  function initProduct() {
    var wrapper = document.querySelector('[data-product-wrapper]');
    if (!wrapper) return;

    var variantJsonEl = document.querySelector('[data-variant-json]');
    if (!variantJsonEl) return;

    var variants;
    try { variants = JSON.parse(variantJsonEl.textContent); } catch (e) { return; }

    var form = document.getElementById('ProductForm');
    var idInput = form ? form.querySelector('[data-variant-id]') : null;
    var priceEl = document.getElementById('ProductPrice');
    var atcBtn = document.querySelector('[data-atc-button]');
    var atcText = document.querySelector('[data-atc-text]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var optionInputs = Array.prototype.slice.call(document.querySelectorAll('[data-variant-option]'));

    function selectedOptions() {
      var groups = document.querySelectorAll('.variant-group');
      var opts = [];
      groups.forEach(function (group) {
        var checked = group.querySelector('input:checked');
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function renderPrice(variant) {
      if (!priceEl || !variant) return;
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        html = '<span class="price price--sale">' +
          '<span class="price__current">' + formatMoney(variant.price) + '</span>' +
          '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>' +
          '<span class="price__badge">-' + pct + '%</span></span>';
      } else {
        html = '<span class="price"><span class="price__current">' + formatMoney(variant.price) + '</span></span>';
      }
      priceEl.innerHTML = html;
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    }

    function markUnavailablePills() {
      // For each option group, grey out values that have no available variant
      // given the OTHER currently selected options.
      var groups = document.querySelectorAll('.variant-group');
      var current = selectedOptions();
      groups.forEach(function (group, gi) {
        group.querySelectorAll('.variant-pill').forEach(function (pill) {
          var input = pill.querySelector('input');
          var test = current.slice();
          test[gi] = input.value;
          var match = variants.find(function (v) {
            return v.options.every(function (o, i) { return o === test[i]; });
          });
          pill.classList.toggle('is-unavailable', !(match && match.available));
        });
      });
    }

    function updateSelectedLabels() {
      document.querySelectorAll('.variant-group').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        var label = group.querySelector('[data-selected-value]');
        if (checked && label) label.textContent = checked.value;
      });
    }

    function updateMedia(variant) {
      if (!variant || !variant.featured_media) return;
      var target = document.querySelector('.product__media[data-media-id="' + variant.featured_media.id + '"]');
      if (!target) return;
      document.querySelectorAll('.product__media').forEach(function (m) { m.classList.remove('is-active'); });
      target.classList.add('is-active');
      document.querySelectorAll('.product__thumb').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-thumb-media') == variant.featured_media.id);
      });
    }

    function onVariantChange() {
      var variant = findVariant(selectedOptions());
      updateSelectedLabels();
      markUnavailablePills();

      if (!variant) {
        if (atcBtn) { atcBtn.disabled = true; }
        if (atcText) { atcText.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = variant.id;
      renderPrice(variant);
      updateMedia(variant);

      if (atcBtn && atcText) {
        if (variant.available) {
          atcBtn.disabled = false;
          atcText.textContent = 'Add to bag';
        } else {
          atcBtn.disabled = true;
          atcText.textContent = 'Sold out';
        }
      }

      // Keep URL shareable
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', onVariantChange);
    });
    markUnavailablePills();

    /* Quantity stepper */
    var qtyInput = document.querySelector('[data-qty-input]');
    var minus = document.querySelector('[data-qty-minus]');
    var plus = document.querySelector('[data-qty-plus]');
    if (qtyInput && minus && plus) {
      minus.addEventListener('click', function () {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
      });
      plus.addEventListener('click', function () {
        qtyInput.value = parseInt(qtyInput.value || '1', 10) + 1;
      });
    }

    /* Gallery thumbs */
    document.querySelectorAll('[data-thumb-media]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-thumb-media');
        document.querySelectorAll('.product__media').forEach(function (m) {
          m.classList.toggle('is-active', m.getAttribute('data-media-id') === id);
        });
        document.querySelectorAll('.product__thumb').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });

    /* AJAX add-to-cart (stays on page, updates header count) */
    if (form) {
      form.addEventListener('submit', function (e) {
        // Let dynamic checkout buttons behave normally; intercept only main submit
        e.preventDefault();
        var fd = new FormData(form);
        if (atcText) atcText.textContent = 'Adding\u2026';
        fetch(window.routes.cart_add_url + '.js', { method: 'POST', body: fd })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(function () { return fetch(window.routes.cart_url + '.js'); })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var count = document.getElementById('CartCount');
            if (count) {
              count.textContent = cart.item_count;
              count.classList.toggle('is-empty', cart.item_count === 0);
            }
            if (atcText) atcText.textContent = 'Added \u2713';
            setTimeout(function () { onVariantChange(); }, 1600);
          })
          .catch(function () {
            if (atcText) atcText.textContent = 'Try again';
          });
      });
    }

    /* Sticky mobile bar: show when main ATC scrolls out of view */
    var stickyBar = document.getElementById('StickyBar');
    var stickyAtc = document.querySelector('[data-sticky-atc]');
    if (stickyBar && atcBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var visible = entries[0].isIntersecting;
        stickyBar.classList.toggle('is-visible', !visible);
        stickyBar.setAttribute('aria-hidden', visible ? 'true' : 'false');
      }, { threshold: 0 });
      io.observe(atcBtn);
      if (stickyAtc) {
        stickyAtc.addEventListener('click', function () {
          if (form) form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      }
    }
  }

  /* ============================================================
     HEADER: mobile menu
     ============================================================ */
  function initHeader() {
    var toggle = document.getElementById('MenuToggle');
    var nav = document.getElementById('MobileNav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.hidden = open;
      document.body.style.overflow = open ? '' : 'hidden';
    });
  }

  /* ============================================================
     ANNOUNCEMENT: rotate messages on mobile
     ============================================================ */
  function initAnnouncement() {
    var items = document.querySelectorAll('.announcement-bar__item');
    if (items.length < 2 || window.innerWidth >= 990) return;
    var i = 0;
    items[0].classList.add('is-shown');
    setInterval(function () {
      items[i].classList.remove('is-shown');
      i = (i + 1) % items.length;
      items[i].classList.add('is-shown');
    }, 4000);
  }

  /* ============================================================
     FOOTER: mobile accordions
     ============================================================ */
  function initFooter() {
    document.querySelectorAll('[data-footer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (window.innerWidth >= 750) return;
        var col = btn.closest('.site-footer__col');
        var open = col.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ============================================================
     COLLECTION: sort select
     ============================================================ */
  function initCollection() {
    var select = document.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ============================================================
     CART: qty change on input
     ============================================================ */
  function initCart() {
    document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        var f = input.closest('form');
        if (f) f.submit();
      });
    });
  }


  /* ============================================================
     WISHLIST: localStorage hearts (cards + product page)
     ============================================================ */
  function initWishlist() {
    var KEY = 'sf_wishlist';
    function read() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }
    function write(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      var list = read();
      if (list.indexOf(handle) > -1) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var l = read();
        var i = l.indexOf(handle);
        if (i > -1) { l.splice(i, 1); } else { l.push(handle); }
        write(l);
        var active = i === -1;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', String(active));
      });
    });
  }

  /* ============================================================
     SIZE GUIDE modal
     ============================================================ */
  function initSizeGuide() {
    var modal = document.getElementById('SizeGuideModal');
    if (!modal) return;
    document.querySelectorAll('[data-open-size-guide]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
      });
    });
    modal.querySelectorAll('[data-close-modal]').forEach(function (el) {
      el.addEventListener('click', function () {
        modal.hidden = true;
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        modal.hidden = true;
        document.body.style.overflow = '';
      }
    });
  }


  /* ============================================================
     COLLECTION FILTERS: drawer + auto-apply
     ============================================================ */
  function initFilters() {
    var form = document.querySelector('[data-filter-form]');
    if (!form) return;

    var panel = document.getElementById('FilterPanel');
    var overlay = document.querySelector('.filter-overlay');

    document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = panel.classList.toggle('is-open');
        if (overlay) overlay.hidden = !open;
        document.body.style.overflow = open ? 'hidden' : '';
      });
    });

    function apply() {
      var params = new URLSearchParams(new FormData(form));
      // strip empty price fields so URLs stay clean
      var clean = new URLSearchParams();
      params.forEach(function (v, k) { if (v !== '') clean.append(k, v); });
      window.location.href = window.location.pathname + '?' + clean.toString();
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); apply(); });

    // Checkboxes apply instantly on desktop; on mobile wait for Apply button
    form.querySelectorAll('input[type="checkbox"][data-filter-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (window.innerWidth >= 990) apply();
      });
    });

    // Price inputs: apply on Enter or after leaving the field (desktop)
    form.querySelectorAll('input[type="number"][data-filter-input]').forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); apply(); }
      });
      input.addEventListener('change', function () {
        if (window.innerWidth >= 990) apply();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initProduct();
    initHeader();
    initAnnouncement();
    initFooter();
    initCollection();
    initCart();
    initWishlist();
    initSizeGuide();
    initFilters();
  });
})();
